export default [
  {
    type: 'Other',
    opts: [
      {
        idx: 0,
        name: 'Custom',
        value: '',
        type: 'Other',
        placeholder: 'value',
        editable: true,
        description: '',
      },
      {
        idx: 1,
        name: 'Dynamic Text Parameter',
        value: '',
        type: 'Other',
        placeholder: 'value',
        editable: true,
        link: '/help/dynamic-text-replacement',
        description: 'Dynamic Text Help',
      },
    ],
  },
  {
    type: 'UTM',
    opts: [
      {
        idx: 2,
        name: 'Campaign Source',
        value: 'utm_source',
        type: 'UTM',
        placeholder: 'value',
        editable: false,
        description: '(referrer: google, citysearch, newsletter4)',
      },
      {
        idx: 3,
        name: 'Campaign Medium',
        value: 'utm_medium',
        type: 'UTM',
        placeholder: 'value',
        editable: false,
        description: '(marketing medium: cpc, banner, email)',
      },
      {
        idx: 4,
        name: 'Campaign Term',
        value: 'utm_term',
        type: 'UTM',
        placeholder: 'value',
        editable: false,
        description: '(identify the paid keywords)',
      },
      {
        idx: 5,
        name: 'Campaign Content',
        value: 'utm_content',
        type: 'UTM',
        placeholder: 'value',
        editable: false,
        description: '(use to differentiate ads)',
      },
      {
        idx: 6,
        name: 'Campaign Name',
        value: 'utm_campaign',
        type: 'UTM',
        placeholder: 'value',
        editable: false,
        description: '(product, promo code, or slogan)',
      },
    ],
  },
  {
    type: 'Marin',
    opts: [
      {
        idx: 7,
        name: 'Tracking ID',
        value: 'mkwid',
        type: 'Marin',
        placeholder: 'value',
        editable: false,
        description: '',
      },
      {
        idx: 8,
        name: '{Creative} Parameter',
        value: 'pcrid',
        type: 'Marin',
        placeholder: 'value',
        editable: false,
        description: '',
      },
      {
        idx: 9,
        name: 'Keyword',
        value: 'pkw',
        type: 'Marin',
        placeholder: 'value',
        editable: false,
        description: '',
      },
      {
        idx: 10,
        name: 'Matchtype',
        value: 'pmt',
        type: 'Marin',
        placeholder: 'value',
        editable: false,
        description: '',
      },
      {
        idx: 11,
        name: 'Device',
        value: 'pdv',
        type: 'Marin',
        placeholder: 'value',
        editable: false,
        description: '',
      },
    ],
  },
]
